import { render, staticRenderFns } from "./TopThree.vue?vue&type=template&id=4efd8826&scoped=true&"
import script from "./TopThree.vue?vue&type=script&lang=js&"
export * from "./TopThree.vue?vue&type=script&lang=js&"
import style0 from "./TopThree.vue?vue&type=style&index=0&id=4efd8826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efd8826",
  null
  
)

export default component.exports